import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, styled } from "@mui/material";
const StyledModalFooter = styled(Stack, {
    shouldForwardProp: (prop)=>![
            'justifyBetween',
            'justifyCenter',
            'noBoxShadow'
        ].includes(prop.toString())
})(({ justifyBetween, justifyCenter, noBoxShadow, theme })=>({
        backgroundColor: theme.palette.common.white,
        borderBottomLeftRadius: '0.75rem',
        borderBottomRightRadius: '0.75rem',
        boxShadow: noBoxShadow ? 'none' : theme.shadows[3],
        gap: justifyBetween || justifyCenter ? 0 : theme.spacing(1),
        justifyContent: justifyBetween ? 'space-between' : justifyCenter ? 'center' : 'flex-end',
        [theme.breakpoints.down('sm')]: {
            '& > button': {
                width: '100%'
            },
            flexDirection: 'column-reverse',
            gap: theme.spacing(0.5),
            justifyContent: 'center'
        },
        transform: 'translateY(-1px) scaleX(1) scaleY(1)'
    }));
export const ModalFooter = (props)=>/*#__PURE__*/ _jsx(StyledModalFooter, {
        alignItems: "center",
        bottom: 0,
        "data-component": "modalFooter",
        direction: "row",
        justifyBetween: props.justifyBetween,
        justifyCenter: props.justifyCenter,
        left: 0,
        noBoxShadow: props.noBoxShadow,
        padding: 2,
        right: 0,
        role: "presentation",
        children: props.children
    });
ModalFooter.displayName = 'ModalFooter';

//# sourceMappingURL=ModalFooter.js.map